import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const VehoCarrierInput = groupInput({
  productionApiKey: input<string>({ validator: nonEmptyValidator }),
});

export type VehoCarrierValue = InputSchema.Value<typeof VehoCarrierInput>;

export type VehoCarrierForm = InputSchema.Input<typeof VehoCarrierInput>;

export const vehoCarrierDefault = (): VehoCarrierValue => ({
  productionApiKey: "",
});

export const CreateVehoCarrierForm = memo(function CreateVehoCarrierForm({
  carrierInput,
}: {
  carrierInput: VehoCarrierForm;
}) {
  return (
    <RedoTextInput
      label="Production API key"
      placeholder=""
      setValue={carrierInput.inputs.productionApiKey.setValue}
      value={carrierInput.inputs.productionApiKey.value}
    />
  );
});
